import Network from 'shared/libraries/network';
import CONFIG from 'shared/constants/config';

class AuthWsModel extends Network {
  constructor(baseUrl: string, timeout = 120000) {
    super(baseUrl, timeout);
  }

  //POST
  //Авторизация вебсокет
  async postWsAuth<T>(data: {
    socketId: string;
    channelName: string;
  }): Promise<T> {
    return this.send('post', `/broadcasting/auth`, {
      socket_id: data.socketId,
      channel_name: data.channelName,
    });
  }
}

const baseUrl: string = CONFIG.REACT_APP_API_BROADCASTING_BASE_URL as string;

const authWsModel = new AuthWsModel(baseUrl);
export default authWsModel;
